import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/app/global-error.jsx");
